<template>
  <v-select
    :label="$t('depot')"
    :items="depots"
    item-value="id"
    item-text="name"
    v-model="depotId"
    @change="handleChange"
    :rules="[validate]"
  ></v-select>
</template>

<script>
  export default {
    props: {
      value: Object,
      required: { type: Boolean, default: false }
    },
    
    data: () => ({
      depotId: null,
    }),
    computed: {
      depots() { return this.$store.getters.settings.depots; },
      req() { return true; },
    },
    watch: {
      value: {
        immediate: true,
        handler(to) {
          if (to) {
            this.depotId = to.id;
          } else {
            this.depotId = null;
          }
        }
      },
    },
    methods: {
      validate(v) {
        if (this.required) {
          return (!!v || this.$t('errorMessage'));
        } else {
          return true;
        }
      },
      handleChange() { this.$emit('input', this.depots.filter( e => e.id===this.depotId )[0] ); },
    },
  };
</script>


<i18n>
{
  "en": {
    "depot": "Depot",
    "errorMessage": "Please select a depot"
  },
  "es": {
    "depot": "Estación de molienda",
    "errorMessage": "Seleccione un depósito"
  },
  "sw": {
    "depot": "Mwanaume",
    "errorMessage": "Tafadhali chagua bohari"
  }
}
</i18n>
